import { Link } from 'react-router';
import { useI18nContext } from '@/i18n/i18n-react';
import { Button } from '@/components/ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';

/** Desktop header actions: Duplicar and, while not sent, Cancelar campanha (PUSH-10 AC 3). */
export function CampaignDetailsHeaderActions({
  campaignName,
  duplicateHref,
  canCancel,
  isCancelling,
  onCancelConfirm,
}: {
  campaignName: string;
  duplicateHref: string;
  canCancel: boolean;
  isCancelling: boolean;
  onCancelConfirm: () => void;
}) {
  const { LL } = useI18nContext();

  return (
    <div className="flex shrink-0 items-center gap-2 self-end">
      <Button asChild variant="outline">
        <Link to={duplicateHref}>{LL.campaigns.actionsSheet.duplicate()}</Link>
      </Button>
      {canCancel && (
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button
              variant="ghost"
              className="text-destructive hover:text-destructive"
            >
              {LL.campaigns.cancelCampaign()}
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>
                {LL.campaigns.cancelCampaignConfirmTitle()}
              </AlertDialogTitle>
              <AlertDialogDescription>
                {LL.campaigns.cancelCampaignConfirmDescription({
                  campaignName,
                })}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>
                {LL.campaigns.goBackButton()}
              </AlertDialogCancel>
              <AlertDialogAction
                onClick={onCancelConfirm}
                disabled={isCancelling}
                className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
              >
                {isCancelling
                  ? LL.campaignDetails.cancelling()
                  : LL.campaigns.cancelButton()}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </div>
  );
}
